import "./OurMission.css";
import LogoImage from "../../images/LogoCaffeina.jpg";
import Tazzina from "../../images/Tazzina.jpg";

export default function OurMission() {

    return (
        <div id="ourMissionText">
            <h1>La Nostra Mission?</h1>

            <div id="ourMissionWrapper">
                <div id="text">
                    <p><strong>Caffeina</strong> è solo il <strong>n°2</strong> dei negozi da caffè e centro assistenza
                        delle
                        macchine da caffè. E allora <strong>perché</strong> venire da noi?</p>
                </div>
                <img id="ourMissionImage" src={LogoImage} alt="Logo"/>
            </div>

            <div id="ourMissionWrapperImageBehind">
                <p><strong>Perché</strong> noi ci diamo più da fare... vogliamo diventare i più forti.</p>

                <p><strong>Perché non</strong> possiamo permetterci di farvi uscire dai nostri negozi con scatole di
                    caffè
                    in mano o in buste di plastica poco eleganti.</p>

                <p><strong>Perché non</strong> possiamo permetterci di farvi aspettare molto tempo per riparare la
                    vostra
                    macchina da caffè.</p>

                <p><strong>Perché non</strong> possiamo ridare la macchina da caffè senza prima <strong>lavarla e
                    sanificarla</strong>.</p>

                <p><strong>Perché non</strong> possiamo vendervi macchine da caffè senza <strong>spiegarvi come
                    funzionano</strong> e senza <strong>provarle</strong> nel nostro negozio.</p>

                <p><strong>Perché non</strong> possiamo permetterci di dare per scontato che sceglierete noi.</p>
            </div>

            <div id="ourMissionWrapper">
                <img id="ourMissionImage" src={Tazzina} alt="Tazzina"/>
                <div id="text">
                    <p>Naturalmente ci diamo da fare nell’essere gentili e cortesi accogliendovi nei nostri negozi con
                        un
                        cordiale sorriso consigliandovi, ad esempio, che macchinetta scegliere e che caffè bere. </p>

                    <p>Provate da noi la prossima volta, se non altro non dovrai fare una lunga coda.</p>
                </div>
            </div>
        </div>
    )
}